"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const pages_1 = require("../../../pages");
const Aside = ({ asideMobileActive, collapsed, toggle, }) => {
    const Outlet = (0, pages_1.useNamedOutlet)("menu");
    return (react_1.default.createElement("aside", { className: (0, classnames_1.default)("aside", asideMobileActive && "has-aside", {
            collapsed: collapsed,
        }), style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        } },
        !collapsed ? react_1.default.createElement(Outlet, null) : react_1.default.createElement("div", { style: { flex: 1 } }),
        react_1.default.createElement("button", { onClick: toggle, style: {
                background: "transparent",
                border: "0px",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "14px",
                fontWeight: 700,
                whiteSpace: "nowrap",
                padding: 0,
                marginTop: "24px",
                alignSelf: "center",
            } },
            react_1.default.createElement("span", { style: {
                    transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                } },
                react_1.default.createElement("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("rect", { width: "26", height: "26", rx: "13", fill: "#FBFBFD" }),
                    react_1.default.createElement("path", { d: "M15 8L10 13L15 18", stroke: "#374151", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }))),
            !collapsed && react_1.default.createElement("span", null, "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u96A0\u3059"))));
};
exports.default = Aside;
